import React, { useState } from 'react';
import { UploadCloudIcon, XIcon } from 'lucide-react';
import { CATEGORIES, COLORS } from '../../data/products';
import { Product } from '../../types';
interface ProductFormModalProps {
  product: Product | null;
  onClose: () => void;
}
const fieldClass = 'w-full border border-white/10 bg-ink-900 px-4 py-3 text-sm text-white placeholder:text-white/30 focus:border-pink-500 focus:outline-none';
const labelClass = 'block text-[10px] font-bold uppercase tracking-[0.18em] text-white/45';
export function ProductFormModal({
  product,
  onClose
}: ProductFormModalProps) {
  const [active, setActive] = useState(true);
  const [variants, setVariants] = useState<Record<string, number>>(() => {
    const base: Record<string, number> = {};
    COLORS.forEach(c => {
      base[c.id] = product?.colors.some(pc => pc.id === c.id) ? Math.round((product?.stock ?? 0) / (product?.colors.length || 1)) : 0;
    });
    return base;
  });
  return <div className="fixed inset-0 z-[70] flex items-start justify-center overflow-y-auto bg-black/75 p-4 sm:items-center" role="dialog" aria-modal="true" aria-labelledby="product-modal-title" data-id="element-405" data-mp="2xwu6r1elg1r4">
      <div className="w-full max-w-3xl border border-white/10 bg-ink-700" data-id="element-406" data-mp="1q5p0agac9b8b">
        <div className="flex items-center justify-between border-b border-white/8 px-6 py-5" data-id="element-407" data-mp="1q4dte7lljncz">
          <h2 id="product-modal-title" className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-408" data-mp="1v2xiggvhlf9k">
            {product ? 'Editar producto' : 'Agregar producto'}
          </h2>
          <button type="button" onClick={onClose} aria-label="Cerrar" className="p-1.5 text-white/50 transition-colors hover:text-white" data-id="element-409" data-mp="17fz5ht6kspge">
            <XIcon className="h-5 w-5" data-id="element-410" data-mp="erbdlerbn1tv" />
          </button>
        </div>

        <form onSubmit={e => {
        e.preventDefault();
        onClose();
      }} data-id="element-411" data-mp="ep7eda4daqzx">
          <div className="grid gap-5 p-6 sm:grid-cols-2" data-id="element-412" data-mp="bp6z3k50xltt">
            <div className="sm:col-span-2" data-id="element-413" data-mp="bnm45tess0vf">
              <label className={labelClass} htmlFor="p-name" data-id="element-414" data-mp="7o3gipvldbow">
                Nombre del producto
              </label>
              <input id="p-name" required defaultValue={product?.name} placeholder="Banda Elástica Pro" className={`mt-2 ${fieldClass}`} data-id="element-415" data-mp="lfi5reg3e94e" />
            </div>

            <div className="sm:col-span-2" data-id="element-416" data-mp="3oxs6goy2uzre">
              <label className={labelClass} htmlFor="p-desc" data-id="element-417" data-mp="3kv5cahdxp2r1">
                Descripción
              </label>
              <textarea id="p-desc" rows={3} defaultValue={product?.description} placeholder="Contá de qué material es, para qué sirve y cómo se siente al usarlo." className={`mt-2 ${fieldClass} resize-none`} data-id="element-418" data-mp="2psc4uo2fte2" />
            </div>

            <div data-id="element-419" data-mp="194kuf695928e">
              <label className={labelClass} htmlFor="p-price" data-id="element-420" data-mp="1976zmz8kb5ng">
                Precio
              </label>
              <input id="p-price" type="number" required defaultValue={product?.price} placeholder="1290" className={`mt-2 ${fieldClass}`} data-id="element-421" data-mp="2w1ixm15j3xfv" />
            </div>

            <div data-id="element-422" data-mp="2n14bx0onkgbu">
              <label className={labelClass} htmlFor="p-sale" data-id="element-423" data-mp="2n2p5amz8dt84">
                Precio con descuento
              </label>
              <input id="p-sale" type="number" defaultValue={product?.salePrice ?? ''} placeholder="990" className={`mt-2 ${fieldClass}`} data-id="element-424" data-mp="3ers961n7h1k8" />
            </div>

            <div data-id="element-425" data-mp="35y5igpxuuohw">
              <label className={labelClass} htmlFor="p-cat" data-id="element-426" data-mp="35xlxt1gtlm06">
                Categoría
              </label>
              <select id="p-cat" defaultValue={product?.category ?? 'bandas'} className={`mt-2 ${fieldClass}`} data-id="element-427" data-mp="3tng9hfpel4iu">
                {CATEGORIES.map(cat => <option key={cat.id} value={cat.id} data-id="element-428" data-mp="24vdet6u4fslw">
                    {cat.label}
                  </option>)}
              </select>
            </div>

            <div data-id="element-429" data-mp="20vcy1fjjv5bo">
              <span className={labelClass} data-id="element-430" data-mp="1vuowhzxp3637">Estado</span>
              <div className="mt-2 flex h-[46px] items-center gap-3 border border-white/10 bg-ink-900 px-4" data-id="element-431" data-mp="1vw046au9gxzl">
                <button type="button" role="switch" aria-checked={active} onClick={() => setActive(v => !v)} className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${active ? 'bg-pink-500' : 'bg-ink-500'}`} data-id="element-432" data-mp="2smsip41jqhz9">
                  <span className={`absolute top-1 h-4 w-4 rounded-full bg-white transition-all ${active ? 'left-6' : 'left-1'}`} data-id="element-433" data-mp="3c9gpof2o0hdk" />
                </button>
                <span className="text-sm text-white/60" data-id="element-434" data-mp="3evg1u6hjj048">
                  {active ? 'Activo en la tienda' : 'Inactivo'}
                </span>
              </div>
            </div>

            <fieldset className="sm:col-span-2" data-id="element-435" data-mp="3opznplqqknpe">
              <legend className={labelClass} data-id="element-436" data-mp="3ste5ohy8je5h">Stock por color / variante</legend>
              <div className="mt-3 grid gap-3 sm:grid-cols-2" data-id="element-437" data-mp="1ml3barph8zd">
                {COLORS.map(color => <label key={color.id} className="flex items-center gap-3 border border-white/10 bg-ink-900 px-3 py-2.5" data-id="element-438" data-mp="6lekpea45k4t">
                    <span className="h-5 w-5 shrink-0 rounded-full border border-white/20" style={{
                  backgroundColor: color.hex
                }} aria-hidden data-id="element-439" data-mp="beqwuoxlvygo" />
                    <span className="flex-1 text-sm text-white/70" data-id="element-440" data-mp="pbe3jjfd22zs">
                      {color.name}
                    </span>
                    <input type="number" min={0} value={variants[color.id]} onChange={e => setVariants(prev => ({
                  ...prev,
                  [color.id]: Number(e.target.value)
                }))} aria-label={`Stock ${color.name}`} className="w-20 border border-white/10 bg-ink-800 px-2 py-1.5 text-right text-sm text-white focus:border-pink-500 focus:outline-none" data-id="element-441" data-mp="2lftwstccvgya" />
                  </label>)}
              </div>
            </fieldset>

            <div className="sm:col-span-2" data-id="element-442" data-mp="395ehphs2koa7">
              <span className={labelClass} data-id="element-443" data-mp="1jpymz7ew753u">Imágenes</span>
              <div className="mt-3 flex flex-col items-center justify-center border border-dashed border-white/15 bg-ink-900 px-6 py-10 text-center transition-colors hover:border-pink-500/60" data-id="element-444" data-mp="1jqgnwhci27i3">
                <UploadCloudIcon className="h-7 w-7 text-white/30" data-id="element-445" data-mp="3qequ841evhbb" />
                <p className="mt-3 text-sm text-white/60" data-id="element-446" data-mp="3vdjwt1f5tnwp">
                  Arrastrá las imágenes acá o{' '}
                  <span className="text-pink-400 underline" data-id="element-447" data-mp="3hkuaswzmsizl">buscá en tu equipo</span>
                </p>
                <p className="mt-1 text-xs text-white/30" data-id="element-448" data-mp="3lmfkyaks6j63">
                  JPG o PNG, mínimo 1000 × 1000 px
                </p>
              </div>
              {product && <div className="mt-3 flex gap-3" data-id="element-449" data-mp="3cnc134dshzqj">
                  {product.images.map((img, i) => <img key={img + i} src={img} alt="" className="h-16 w-16 border border-white/10 object-cover" data-id="element-450" data-mp="2ynt497qfiatj" data-mpi={i} />)}
                </div>}
            </div>
          </div>

          <div className="flex flex-col gap-3 border-t border-white/8 px-6 py-5 sm:flex-row sm:justify-end" data-id="element-451" data-mp="10w88awhrob3d">
            <button type="button" onClick={onClose} className="border border-white/20 px-6 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-white/70 transition-colors hover:border-white hover:text-white" data-id="element-452" data-mp="3krzdx3mpb8cb">
              Cancelar
            </button>
            <button type="submit" className="bg-pink-500 px-6 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-white transition-colors hover:bg-pink-600" data-id="element-453" data-mp="3644i3edecnv0">
              Guardar producto
            </button>
          </div>
        </form>
      </div>
    </div>;
}